
    const header = document.querySelector('ry-header');
    if (header) {
      const setH = () => document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
      setH();
      new ResizeObserver(setH).observe(header);
    }

    const manifest = await fetch('/dist/docs/manifest.json').then(r => r.json());
    const root = document.getElementById('root');

    // Stable sidebar order
    const CATEGORY_ORDER = ['layout', 'form', 'overlay', 'feedback', 'nav', 'display'];
    const CATEGORY_LABEL = {
      layout: 'Layout', form: 'Forms', overlay: 'Overlays',
      feedback: 'Feedback', nav: 'Navigation', display: 'Display',
    };

    const grouped = new Map();
    for (const doc of manifest) {
      const cat = doc.category || 'other';
      if (!grouped.has(cat)) grouped.set(cat, []);
      grouped.get(cat).push(doc);
    }
    const orderedCats = [
      ...CATEGORY_ORDER.filter(c => grouped.has(c)),
      ...[...grouped.keys()].filter(c => !CATEGORY_ORDER.includes(c)),
    ];

    function buildSidebarHTML() {
      return orderedCats.map(cat => {
        const items = grouped.get(cat)
          .sort((a, b) => a.component.localeCompare(b.component))
          .map(d => `<ry-search-item value="${d.component}">${esc(d.component.replace(/^ry-/, ''))}</ry-search-item>`)
          .join('');
        return `<ry-search-group label="${esc(CATEGORY_LABEL[cat] || cat)}">${items}</ry-search-group>`;
      }).join('');
    }

    // Replace the entire <ry-search-list> element so the parser upgrades a fresh
    // one with children already present. ry-search-list reads children only once
    // in setup() — its own @gotcha. Setting innerHTML on an already-upgraded
    // empty list does nothing.
    function installSearchList(parent, id) {
      parent.innerHTML = `<ry-search-list id="${id}" placeholder="Search components...">${buildSidebarHTML()}</ry-search-list>`;
      return parent.firstElementChild;
    }
    const desktopSearch = installSearchList(document.querySelector('aside'), 'desktop-search');
    root.innerHTML = '';
    for (const cat of orderedCats) {
      for (const doc of grouped.get(cat).sort((a, b) => a.component.localeCompare(b.component))) {
        root.insertAdjacentHTML('beforeend', renderSection(doc));
      }
    }

    function renderSection(d) {
      const examples = d.examples || [];
      const exampleRows = examples.length
        ? examples.map(ex => `
            <div class="example">
              <div class="example-name">@example ${esc(ex.name)}</div>
              ${ex.body}
              <div class="example__resizer" title="Drag to resize" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/></svg>
              </div>
            </div>
          `).join('')
        : `<p style="color:var(--ry-color-text-muted);font-style:italic;">No @example blocks in this component's JSDoc.</p>`;

      return `
<ry-section id="section-${esc(d.component)}">
  <h2 style="font-family:ui-monospace,monospace;">&lt;${esc(d.component)}&gt;</h2>
  <p>${esc(d.summary || '')}</p>
  <div class="demo-block">
    <div class="example-row">${exampleRows}</div>
    ${examples.length ? `
    <button class="code-toggle" aria-expanded="false" aria-label="Show code"
            onclick="const p=this.closest('ry-section').querySelector('.code-panel');p.classList.toggle('open');this.setAttribute('aria-expanded',p.classList.contains('open'))">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>
    </button>` : ''}
  </div>
  <div class="code-panel">
    <h3>${esc(d.component)}</h3>
    ${renderCodeBlocks(examples)}
    ${renderAttributes(d.attributes)}
    ${renderProperties(d.properties)}
    ${renderEvents(d.events)}
    ${renderStates(d.states)}
    ${renderGotchas(d.gotchas)}
    ${renderTutorials(d.tutorials, d.component)}
    ${renderChains(d.chains, d.component)}
  </div>
</ry-section>`;
    }

    function renderCodeBlocks(examples) {
      if (!examples.length) return '';
      return examples.map(ex => `
        <ry-code language="html" title="@example ${esc(ex.name)}">
          <template>${ex.body}</template>
        </ry-code>
      `).join('');
    }

    function renderAttributes(attrs) {
      if (!attrs?.length) return '';
      return `<table>
        <thead><tr><th>Attribute</th><th>Type</th><th>Default</th><th>Description</th></tr></thead>
        <tbody>
          ${attrs.map(a => `<tr>
            <td><code>${esc(a.name)}</code></td>
            <td>${esc(a.type || '')}</td>
            <td><code>${esc(a.default ?? '—')}</code></td>
            <td>${esc(a.description || '')}</td>
          </tr>`).join('')}
        </tbody>
      </table>`;
    }

    function renderProperties(props) {
      if (!props?.length) return '';
      return `<table>
        <thead><tr><th>Property</th><th>Type</th><th>Description</th></tr></thead>
        <tbody>
          ${props.map(p => `<tr>
            <td><code>.${esc(p.name)}</code></td>
            <td>${esc(p.type || '')}</td>
            <td>${esc(p.description || '')}</td>
          </tr>`).join('')}
        </tbody>
      </table>`;
    }

    function renderEvents(events) {
      if (!events?.length) return '';
      return `<table>
        <thead><tr><th>Event</th><th>Detail</th><th>Fires</th></tr></thead>
        <tbody>
          ${events.map(e => `<tr>
            <td><code>${esc(e.name)}</code></td>
            <td><code>${esc(e.detail || '')}</code></td>
            <td>${esc(e.fires || '')}</td>
          </tr>`).join('')}
        </tbody>
      </table>`;
    }

    function renderStates(states) {
      if (!states?.length) return '';
      return `<table>
        <thead><tr><th>State</th><th>Meaning</th></tr></thead>
        <tbody>
          ${states.map(s => {
            const i = s.indexOf(' ');
            const name = i > 0 ? s.slice(0, i) : s;
            const desc = i > 0 ? s.slice(i + 1) : '';
            return `<tr><td><code>${esc(name)}</code></td><td>${esc(desc)}</td></tr>`;
          }).join('')}
        </tbody>
      </table>`;
    }

    function renderGotchas(gotchas) {
      if (!gotchas?.length) return '';
      return `<h4 style="margin:1rem 0 0.5rem;font-size:0.85rem;text-transform:uppercase;letter-spacing:0.04em;color:var(--ry-color-text-muted);">Gotchas</h4>
        ${gotchas.map(g => `<div class="gotcha-row">${esc(g)}</div>`).join('')}`;
    }

    function renderTutorials(tutorials, component) {
      if (!tutorials?.length) return '';
      return `<details style="margin-top:1rem;">
        <summary style="cursor:pointer;font-size:0.85rem;text-transform:uppercase;letter-spacing:0.04em;color:var(--ry-color-text-muted);">${tutorials.length} tutorial${tutorials.length === 1 ? '' : 's'} — <code>npm run play -- ${esc(component)}</code></summary>
        ${tutorials.map(t => `<ry-code language="js" title="@tutorial ${esc(t.name)}"><template>${esc(t.body)}</template></ry-code>`).join('')}
      </details>`;
    }

    function renderChains(chains, component) {
      if (!chains?.length) return '';
      return `<details style="margin-top:1rem;">
        <summary style="cursor:pointer;font-size:0.85rem;text-transform:uppercase;letter-spacing:0.04em;color:var(--ry-color-text-muted);">${chains.length} chain${chains.length === 1 ? '' : 's'} (cross-component composition)</summary>
        ${chains.map(c => `<ry-code language="js" title="@chain ${esc(c.partner)}"><template>${esc(c.body)}</template></ry-code>`).join('')}
      </details>`;
    }

    function esc(s) {
      return String(s ?? '').replace(/[&<>"]/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;' }[c]));
    }

    function scrollToSection(value) {
      const section = document.getElementById(`section-${value}`);
      if (!section) return;
      const y = section.getBoundingClientRect().top + window.scrollY - 100;
      window.scrollTo({ top: y, behavior: 'instant' });
    }

    desktopSearch.addEventListener('ry:select', (e) => scrollToSection(e.detail.value));
    desktopSearch.addEventListener('ry:highlight', (e) => scrollToSection(e.detail.value));

    // ── Shoelace-style example resize: drag the right-edge handle to shrink any
    //    example horizontally and preview its responsive behavior. Delegated
    //    once at the document level so it works for any .example__resizer.
    document.addEventListener('pointerdown', (event) => {
      const resizer = event.target.closest('.example__resizer');
      if (!resizer) return;
      const example = resizer.closest('.example');
      if (!example) return;

      event.preventDefault();
      const startX = event.clientX;
      const startWidth = example.getBoundingClientRect().width;
      const MIN_WIDTH = 240;
      resizer.setPointerCapture(event.pointerId);
      example.classList.add('example--dragging');

      const move = (e) => {
        const width = Math.max(MIN_WIDTH, startWidth + (e.clientX - startX));
        example.style.width = `${width}px`;
      };
      const stop = (e) => {
        example.classList.remove('example--dragging');
        try { resizer.releasePointerCapture(e.pointerId); } catch {}
        resizer.removeEventListener('pointermove', move);
        resizer.removeEventListener('pointerup', stop);
        resizer.removeEventListener('pointercancel', stop);
      };
      resizer.addEventListener('pointermove', move);
      resizer.addEventListener('pointerup', stop);
      resizer.addEventListener('pointercancel', stop);
    });
  